import { cn } from '@/lib/utils'

interface StatusBadgeProps {
  label?: string
  color: string
  textColor: string
  className?: string
  children?: React.ReactNode
}

export function StatusBadge({ label, color, textColor, className, children }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        color,
        textColor,
        className,
      )}
    >
      {children ?? label}
    </span>
  )
}
